/*
* JAVA 代码来自于小熊
* https://app.yinxiang.com/fx/303b7238-0add-44f5-9632-99baad05afe1
*/

/* Generated from Java with JSweet 3.0.0 - http://www.jsweet.org */
const StringUtils = /** @class */ (function () {
  function StringUtils() {
  }
  /**
   * ���������������������������
   * @param {number} x
   * @return {number}
   */
  StringUtils.sizeOfInt = function (x) {
      return x === 0 ? 1 : /* valueOf */ String(x).toString().length;
  };
  /**
   * ������������������������������������������
   * @param {string} str
   * @return {boolean}
   */
  StringUtils.isCharEqual = function (str) {
      return /* replace */ str.split(str.charAt(0)).join(' ').trim().length === 0;
  };
  /**
   * ������������������������������
   * @param {string} str
   * @return {boolean}
   */
  StringUtils.isNumeric = function (str) {
      for (var i = str.length; --i >= 0;) {
          {
              if (!/\d/.test(str.charAt(i)[0])) {
                  return false;
              }
          }
          ;
      }
      return true;
  };
  /**
   * ������������������������������������(���)������null���
   * @param {string} str
   * @return {boolean}
   */
  StringUtils.equalsNull = function (str) {
      return str === null || str === undefined || str.trim() === '';
  };
  return StringUtils;
}());
StringUtils["__class"] = "StringUtils";

var CheckStrength = /** @class */ (function () {
  function CheckStrength() {
  }
  CheckStrength.DICTIONARY_$LI$ = function () { if (CheckStrength.DICTIONARY == null) {
      CheckStrength.DICTIONARY = ["password", "abc123", "iloveyou", "adobe123", "123123", "sunshine", "1314520", "a1b2c3", "123qwe", "aaa111", "qweasd", "admin", "passwd"];
  } return CheckStrength.DICTIONARY; };
  /**
   * ���������������������������num������������������������������������������������
   *
   * @param {string} c
   * @return
   * @return {number}
   * @private
   */
  CheckStrength.checkCharacterType = function (c) {
      if ((function (c) { return c.charCodeAt == null ? c : c.charCodeAt(0); })(c) >= 48 && (function (c) { return c.charCodeAt == null ? c : c.charCodeAt(0); })(c) <= 57) {
          return CheckStrength.NUM;
      }
      if ((function (c) { return c.charCodeAt == null ? c : c.charCodeAt(0); })(c) >= 65 && (function (c) { return c.charCodeAt == null ? c : c.charCodeAt(0); })(c) <= 90) {
          return CheckStrength.CAPITAL_LETTER;
      }
      if ((function (c) { return c.charCodeAt == null ? c : c.charCodeAt(0); })(c) >= 97 && (function (c) { return c.charCodeAt == null ? c : c.charCodeAt(0); })(c) <= 122) {
          return CheckStrength.SMALL_LETTER;
      }
      return CheckStrength.OTHER_CHAR;
  };
  /**
   * ������������������������������������
   *
   * @param {string} passwd
   * @param {number} type
   * @return
   * @return {number}
   * @private
   */
  CheckStrength.countLetter = function (passwd, type) {
      var count = 0;
      if (null != passwd && passwd.length > 0) {
          {
              var array12059 = /* toCharArray */ (passwd).split('');
              for (var index12058 = 0; index12058 < array12059.length; index12058++) {
                  var c = array12059[index12058];
                  {
                      if (CheckStrength.checkCharacterType(c) === type) {
                          count++;
                      }
                  }
              }
          }
      }
      return count;
  };
  /**
   * ���������������������
   *
   * @param {string} passwd
   * @return {number} strength level
   */
  CheckStrength.checkPasswordStrength = function (passwd) {
      if (StringUtils.equalsNull(passwd)) {
          throw Object.defineProperty(new Error("password is empty"), '__classes', { configurable: true, value: ['java.lang.Throwable', 'java.lang.Object', 'java.lang.RuntimeException', 'java.lang.IllegalArgumentException', 'java.lang.Exception'] });
      }
      var len = passwd.length;
      var level = 0;
      if (CheckStrength.countLetter(passwd, CheckStrength.NUM) > 0) {
          level++;
      }
      if (CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) > 0) {
          level++;
      }
      if (len > 4 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) > 0) {
          level++;
      }
      if (len > 6 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) > 0) {
          level++;
      }
      if (len > 4 && CheckStrength.countLetter(passwd, CheckStrength.NUM) > 0 && CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) > 0 || CheckStrength.countLetter(passwd, CheckStrength.NUM) > 0 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) > 0 || CheckStrength.countLetter(passwd, CheckStrength.NUM) > 0 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) > 0 || CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) > 0 || CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) > 0 || CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) > 0) {
          level++;
      }
      if (len > 6 && CheckStrength.countLetter(passwd, CheckStrength.NUM) > 0 && CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) > 0 || CheckStrength.countLetter(passwd, CheckStrength.NUM) > 0 && CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) > 0 || CheckStrength.countLetter(passwd, CheckStrength.NUM) > 0 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) > 0 || CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) > 0) {
          level++;
      }
      if (len > 8 && CheckStrength.countLetter(passwd, CheckStrength.NUM) > 0 && CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) > 0 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) > 0) {
          level++;
      }
      if (len > 6 && CheckStrength.countLetter(passwd, CheckStrength.NUM) >= 3 && CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) >= 3 || CheckStrength.countLetter(passwd, CheckStrength.NUM) >= 3 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) >= 3 || CheckStrength.countLetter(passwd, CheckStrength.NUM) >= 3 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 2 || CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) >= 3 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) >= 3 || CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) >= 3 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 2 || CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) >= 3 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 2) {
          level++;
      }
      if (len > 8 && CheckStrength.countLetter(passwd, CheckStrength.NUM) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) >= 2 || CheckStrength.countLetter(passwd, CheckStrength.NUM) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 2 || CheckStrength.countLetter(passwd, CheckStrength.NUM) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 2 || CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 2) {
          level++;
      }
      if (len > 10 && CheckStrength.countLetter(passwd, CheckStrength.NUM) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) >= 2 && CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 2) {
          level++;
      }
      if (CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 3) {
          level++;
      }
      if (CheckStrength.countLetter(passwd, CheckStrength.OTHER_CHAR) >= 6) {
          level++;
      }
      if (len > 12) {
          level++;
          if (len >= 16) {
              level++;
          }
      }
      if ("abcdefghijklmnopqrstuvwxyz".indexOf(passwd) > 0 || "ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(passwd) > 0) {
          level--;
      }
      if ("qwertyuiop".indexOf(passwd) > 0 || "asdfghjkl".indexOf(passwd) > 0 || "zxcvbnm".indexOf(passwd) > 0) {
          level--;
      }
      if (StringUtils.isNumeric(passwd) && ("01234567890".indexOf(passwd) > 0 || "09876543210".indexOf(passwd) > 0)) {
          level--;
      }
      if (CheckStrength.countLetter(passwd, CheckStrength.NUM) === len || CheckStrength.countLetter(passwd, CheckStrength.SMALL_LETTER) === len || CheckStrength.countLetter(passwd, CheckStrength.CAPITAL_LETTER) === len) {
          level--;
      }
      if (len % 2 === 0) {
          var part1 = passwd.substring(0, (len / 2 | 0));
          var part2 = passwd.substring((len / 2 | 0));
          if (part1 === part2) {
              level--;
          }
          if (StringUtils.isCharEqual(part1) && StringUtils.isCharEqual(part2)) {
              level--;
          }
      }
      if (len % 3 === 0) {
          var part1 = passwd.substring(0, (len / 3 | 0));
          var part2 = passwd.substring((len / 3 | 0), (len / 3 | 0) * 2);
          var part3 = passwd.substring((len / 3 | 0) * 2);
          if ((part1 === part2) && (part2 === part3)) {
              level--;
          }
      }
      if (StringUtils.isNumeric(passwd) && len >= 6) {
          var year = 0;
          if (len === 8 || len === 6) {
              year = /* parseInt */ parseInt(passwd.substring(0, len - 4));
          }
          var size = StringUtils.sizeOfInt(year);
          var month = parseInt(passwd.substring(size, size + 2));
          var day = parseInt(passwd.substring(size + 2, size + 4));
          if (year >= 1950 && year < 2050 && month >= 1 && month <= 12 && day >= 1 && day <= 31) {
              level--;
          }
      }
      if (null != CheckStrength.DICTIONARY_$LI$() && CheckStrength.DICTIONARY_$LI$().length > 0) {
          for (var i = 0; i < CheckStrength.DICTIONARY_$LI$().length; i++) {
              {
                  if ((passwd === (CheckStrength.DICTIONARY_$LI$()[i])) || CheckStrength.DICTIONARY_$LI$()[i].indexOf(passwd) >= 0) {
                      level--;
                      break;
                  }
              }
              ;
          }
      }
      if (len <= 6) {
          level--;
          if (len <= 4) {
              level--;
              if (len <= 3) {
                  level = 0;
              }
          }
      }
      if (StringUtils.isCharEqual(passwd)) {
          level = 0;
      }
      if (level < 0) {
          level = 0;
      }
      return level;
  };
  /**
   * ������������������������������������������������������������������
   *
   * @param {string} passwd
   * @return
   * @return {CheckStrength.LEVEL}
   */
  CheckStrength.getPasswordLevel = function (passwd) {
      var level = CheckStrength.checkPasswordStrength(passwd);
      switch ((level)) {
          case 0:
          case 1:
          case 2:
          case 3:
              return 'EASY';
          case 4:
          case 5:
          case 6:
              return 'MIDIUM';
          case 7:
          case 8:
          case 9:
              return 'STRONG';
          case 10:
          case 11:
          case 12:
              return 'VERY_STRONG';
          default:
              return 'EXTREMELY_STRONG';
      }
  };
  /**
   * NUM ������
   * SMALL_LETTER ������������
   * CAPITAL_LETTER ������������
   * OTHER_CHAR  ������������
   */
  CheckStrength.NUM = 1;
  CheckStrength.SMALL_LETTER = 2;
  CheckStrength.CAPITAL_LETTER = 3;
  CheckStrength.OTHER_CHAR = 4;
  return CheckStrength;
}());
CheckStrength["__class"] = "CheckStrength";

// console.log(CheckStrength.getPasswordLevel('123123'))
export default CheckStrength
